import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "../common/svg-icon";
import style from "./menu-item.css";

function MenuItem({ value, onClick, icon = "chevron", displayIcon = true }) {
    return (
        <li className={style.container} onClick={onClick}>
            <p className={style.value}>{value}</p>
            {displayIcon && (
                <div className={style.icon}>
                    <SVGIcon name={icon} />
                </div>
            )}
        </li>
    );
}

export default MenuItem;

MenuItem.propTypes = {
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string,
    displayIcon: PropTypes.bool
};

MenuItem.defaultProps = {
    icon: "chevron",
    displayIcon: true
};
